import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

/**
 * Utility function to set common border/color/focus styles across form Inputs
 * @param hasError - error state (boolean)
 * @param theme - reference to current theme
 */
/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function setFormInputStyle(hasError = false, theme: any): string {
  return `
    cursor: pointer;
    background-color: ${theme.colors.form.input.background.enabled};
    color: ${
      hasError
        ? theme.colors.state.danger
        : theme.colors.form.text.input.enabled
    };
    border: 1px solid transparent;
    border-bottom-color: ${
      hasError
        ? theme.colors.state.danger
        : theme.colors.form.input.border.enabled
    };
    outline: none;

    &:focus {
      outline: none;
      color: ${
        hasError
          ? theme.colors.state.danger
          : theme.colors.form.text.input.enabled
      };
      border-color: ${
        hasError
          ? theme.colors.state.danger
          : theme.colors.form.input.border.focus
      };
    }
      
    &::placeholder {
      color: ${theme.colors.form.input.placeholder};
    }

    &:disabled {
      cursor: not-allowed;
      color: ${theme.colors.form.text.input.disabled};
      border-bottom-color: ${theme.colors.form.input.border.disabled};
      background-color: ${theme.colors.form.input.background.disabled};
      > svg {
        fill: ${theme.colors.form.text.input.disabled};
      }
    }
  `;
}

export default styled.form<SpaceProps>`
  ${({ theme }) => `padding: ${theme.space[4]}px;`}
  ${space}
`;
